import { render, staticRenderFns } from "./Globals.vue?vue&type=template&id=7e7d87de"
import script from "./Globals.vue?vue&type=script&lang=ts"
export * from "./Globals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports